export const ADD_MOVIE = "ADD_MOVIE"
export const DELETE_MOVIE = "DELETE_MOVIE"
export const UPDATE_MOVIE = "UPDATE_MOVIE"
export const SEARCH_MOVIE = "SEARCH_MOVIE"